import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TranslateModule } from "@ngx-translate/core";
import { TranslateService } from "@ngx-translate/core";
import { LanguageSelectionComponent } from './components/languageSelection/language-selection.component';
import { LanguageEnum } from './enums';
import { SESSION_KEY_NAME } from './constants';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, LanguageSelectionComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'auth-client';
  protected selectLangCode: LanguageEnum = LanguageEnum.En

  constructor(
    private _translate: TranslateService,
    private _route: ActivatedRoute,
  ) {
    this._translate.addLangs(Object.values(LanguageEnum));
  }

  ngOnInit(): void {
    this._route.queryParamMap.subscribe((params) => {
      let langCode = params.get(SESSION_KEY_NAME.MAIN.lang) as LanguageEnum

      if (langCode && !Object.values(LanguageEnum).includes(langCode)) {
        langCode = LanguageEnum.En
      } else if (langCode) {
        this._storeLang(langCode)
      }

      const currLangCode = langCode ?? localStorage.getItem(SESSION_KEY_NAME.MAIN.lang) as LanguageEnum ?? this.selectLangCode

      this.selectLangCode = currLangCode

      this._onUseLang(currLangCode)
    })

  }

  onSelectLanguage(lang: LanguageEnum) {
    this._storeLang(lang)
    this._onUseLang(lang)
  }

  private _storeLang(lang: string) {
    localStorage.setItem(SESSION_KEY_NAME.MAIN.lang, lang)
  }

  private _onUseLang(lang: string) {
    this._translate.use(lang);
  }
}
